// extracted by mini-css-extract-plugin
module.exports = {"miniTitle":"SmallWrapper_miniTitle__a4hsV","smallWrapper":"SmallWrapper_smallWrapper__d4PzC"};